import { ChainId, NATIVE_CURRENCY } from '../constants'
import { useEthers } from './useEthers'
import { useBalance } from './useBalance'

export function useEthBalance() {
  const { chainId = ChainId.Mainnet } = useEthers()
  return useBalance(NATIVE_CURRENCY[chainId])
}
